import { render, staticRenderFns } from "./ProductViewerCaseViewer.vue?vue&type=template&id=4f155695&scoped=true&"
import script from "./ProductViewerCaseViewer.vue?vue&type=script&lang=js&"
export * from "./ProductViewerCaseViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewerCaseViewer.vue?vue&type=style&index=0&id=4f155695&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f155695",
  null
  
)

export default component.exports